import {$post} from "./base"

export async function index(params) {
    return $post("/kehu/index",params);
  }
  export async function addkehu(params) {
    return $post("/kehu/addkehu",params);
  }